module.exports = __webpack_public_path__ + "img/bg-compliance-1.1a921447.png";